'use strict'
/* global SENTRY_DSN, USER_SENTRY_DSN, WIX_DATA_SENTRY_DSN, self */

const appName = 'dbsm-viewer-app'
const RavenConstructor = require('raven-js/src/raven')
const Raven = new RavenConstructor()
require('../raven/setupRaven')(Raven, self, SENTRY_DSN, {}, appName)
require('../raven/registerRavenToUnexpectedErrors')(Raven, self, appName)
const UserRaven = new RavenConstructor()
require('../raven/setupUserRaven')(
  UserRaven,
  self,
  USER_SENTRY_DSN,
  {},
  appName
)
const WixDataRaven = new RavenConstructor()
require('../raven/setupRaven')(
  WixDataRaven,
  self,
  WIX_DATA_SENTRY_DSN,
  {},
  appName
)
const { setupBiLogger, setupErrorBiLogger } = require('../bi/setupBiLogger')
const createWixData = require('wix-code-platform/create-wix-data')
const createWixDataSchemas = require('wix-code-platform/create-wix-data-schemas')
const createApp = require('./appCreator')

const errorReporter = (message, error) => console.error(message, error) // eslint-disable-line no-console

const app = createApp({
  wixDataCreator: () => ({
    wixData: createWixData(global.elementorySupport),
    wixDataSchemas: createWixDataSchemas(global.elementorySupport)
  }),
  wixSdk: global.wix,
  elementorySupport: global.elementorySupport,
  errorReporter,
  Raven,
  UserRaven,
  WixDataRaven,
  biLogger: setupBiLogger(),
  errorBiLogger: setupErrorBiLogger()
})

module.exports = app



// WEBPACK FOOTER //
// ./viewer-app-module/index.js